import SystemOverview from './SystemOverview'

const ROUTES = [
  SystemOverview
]

export default ROUTES
